import React from 'react';
import { Typography } from '@mui/material';
import { colors } from '../../theme/tokens';

/**
 * Phase 4 — the position glyph shared by the env strip + tenant card:
 *   "✦ latest" (textTertiary) when this env holds the newest version, or
 *   "◀ N behind" (warningText) when it lags. Pure presentational.
 */
interface VersionDeltaChipProps {
  behind: number;
  isLatest: boolean;
}

const VersionDeltaChip: React.FC<VersionDeltaChipProps> = ({ behind, isLatest }) => {
  if (isLatest) {
    return (
      <Typography component="span" sx={{ fontSize: 12, fontWeight: 600, color: colors.textTertiary }}>
        ✦ latest
      </Typography>
    );
  }
  if (behind > 0) {
    return (
      <Typography component="span" sx={{ fontSize: 12, fontWeight: 600, color: colors.warningText }}>
        ◀ {behind} behind
      </Typography>
    );
  }
  return null;
};

export default VersionDeltaChip;
